import { render, staticRenderFns } from "./CotizacionesLista.vue?vue&type=template&id=60381147&"
import script from "./CotizacionesLista.vue?vue&type=script&lang=js&"
export * from "./CotizacionesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports